import CheckboxSelectAll from '@stimulus-components/checkbox-select-all'

export default class extends CheckboxSelectAll {
  static targets = ['count', 'bulkDealLink', 'allSelectedHint']
  static values = { totalCount: Number, allSelectedUrl: String }
  declare readonly countTarget: HTMLElement
  declare readonly hasCountTarget: boolean
  declare readonly bulkDealLinkTarget: HTMLAnchorElement
  declare readonly hasBulkDealLinkTarget: boolean
  declare readonly allSelectedHintTarget: HTMLElement
  declare readonly hasAllSelectedHintTarget: boolean
  declare readonly totalCountValue: number
  declare readonly hasTotalCountValue: boolean
  declare readonly allSelectedUrlValue: string

  // NOTE: 全件モード中は、未読み込みのカードも含めた検索結果の全件を紹介先にする
  private allSelected = false
  private defaultBulkDealUrl?: string

  checkboxTargetConnected(checkbox: HTMLInputElement): void {
    // NOTE: 追加カードはまとめて接続されるため、全カードに先にチェックを付ける
    if (this.allSelected) {
      this.checkboxTargets.forEach((target) => {
        target.checked = true
      })
    }
    super.checkboxTargetConnected(checkbox)
  }

  toggle(event: Event): void {
    super.toggle(event)
    if (this.hasTotalCountValue) this.allSelected = this.checkboxAllTarget.checked
    // NOTE: 親の toggle は input しか飛ばさないため change 起点の refresh が走らない。件数表示のために明示的に呼ぶ
    this.refresh()
  }

  refresh(): void {
    super.refresh()

    if (this.allSelected && this.unchecked.length > 0) this.allSelected = false
    if (this.hasCountTarget) this.countTarget.textContent = String(this.selectedCount)
    if (this.hasAllSelectedHintTarget) this.allSelectedHintTarget.hidden = !this.allSelected
    this.updateBulkDealLink()
  }

  releaseAllSelected(event: CustomEvent): void {
    if (!this.allSelected) return
    if ((event.target as HTMLElement).id !== 'bulk_deals' || !event.detail.success) return

    // NOTE: 全件選択の送信後はカードが描き直されないため、ここでチェックを外す
    this.allSelected = false
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false
    })
    this.refresh()
  }

  private get selectedCount(): number {
    return this.allSelected ? this.totalCountValue : this.checked.length
  }

  private updateBulkDealLink(): void {
    if (!this.hasBulkDealLinkTarget) return

    this.defaultBulkDealUrl ??= this.bulkDealLinkTarget.href
    if (this.allSelected) {
      this.bulkDealLinkTarget.href = this.allSelectedUrlValue
      return
    }

    const paramName = 'outside_group_toa_selected'
    const hasOutsideGroupToa = this.checked.some(
      (checkbox: HTMLInputElement) => checkbox.dataset['groupMemberToa'] !== 'true',
    )
    const url = new URL(this.defaultBulkDealUrl)
    if (hasOutsideGroupToa) {
      url.searchParams.set(paramName, '1')
    } else {
      url.searchParams.delete(paramName)
    }
    this.bulkDealLinkTarget.href = url.toString()
  }
}
